import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useCustomerStore } from '@/my/modules/account/stores/customer.store'

export const useAuthStore = defineStore(
  'auth',
  () => {
    const loaded = ref(false)
    const customerStore = useCustomerStore()
    const isAuthenticated = ref(false)

    function clear() {
      loaded.value = false
      isAuthenticated.value = false
      customerStore.clear()
    }

    return {
      loaded,
      clear,
      isAuthenticated
    }
  },
  {
    persist: {
      key: `my-session-${import.meta.env.VITE_APP_ENV}`,
      pick: ['isAuthenticated']
    }
  }
)
